import { useMutation } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export function useGetPresignedUrlV2() {
  return useMutation(trpcOptions.app.getPresignedUrlV2.mutationOptions())
}
